import { defineStore } from 'pinia'
import { useSocketIOStore } from './socket-io'
import { NOTIFICATIONS_TYPES } from '@shared/constants'
import { useMessagesStore } from './messages'

export const useImportsStore = defineStore('imports', {
  state: () => ({
    imports: {}
  }),
  actions: {
    init(vm) {
      const socketIoStore = useSocketIOStore()
      const socket = socketIoStore.socket
      const parseSocketData = socketIoStore.getSocketDataParser()
      const moduleName = this.$id

      socket?.on('importProcessing', (data) => {
        const { isValidId, id, originKey, storedItem } = parseSocketData(
          data,
          this.imports
        )
        if (!isValidId) return
        vm?.$log?.debug('Imports | importProcessing')

        const message = {
          id,
          read: false,
          operation: {
            module: moduleName,
            originKey,
            type: NOTIFICATIONS_TYPES.LOADING,
            ...storedItem
          }
        }
        const messagesStore = useMessagesStore()
        messagesStore.updateMessage({ id, changedProp: message }, true)
      })

      socket?.on('importSuccess', (data) => {
        const { isValidId, id, originKey, parsedData, storedItem } =
          parseSocketData(data, this.imports)
        if (!isValidId) return
        vm?.$log?.debug('Imports | importSuccess')

        // We add the succeeded state to true, so in case of unordered messages, we don't change the state
        const message = {
          read: false,
          succeeded: true,
          operation: {
            originKey,
            module: moduleName,
            url: parsedData.url,
            type: NOTIFICATIONS_TYPES.SUCCESS,
            ...storedItem
          }
        }
        const messagesStore = useMessagesStore()
        messagesStore.updateMessage({ id, changedProp: message })
        socketIoStore.removeActiveId(id)
      })

      socket?.on('importError', (data) => {
        const { isValidId, id, originKey, storedItem } = parseSocketData(
          data,
          this.imports
        )
        if (!isValidId) return
        vm?.$log?.debug('Imports | importError')

        const message = {
          read: false,
          operation: {
            originKey,
            module: moduleName,
            type: NOTIFICATIONS_TYPES.ERROR,
            ...storedItem
          }
        }
        const messagesStore = useMessagesStore()
        messagesStore.updateMessage({ id, changedProp: message })
        socketIoStore.removeActiveId(id)
      })
    },
    setNewImport({ importId, payload }) {
      const messagesStore = useMessagesStore()
      const message = {
        id: importId,
        read: false,
        operation: {
          module: this.$id,
          type: NOTIFICATIONS_TYPES.LOADING,
          ...payload
        }
      }
      this.imports = { ...this.imports, [importId]: payload }
      messagesStore.setLocalMessage(message)
      useSocketIOStore().setActiveId(importId)
    }
  }
})
